// extracted by mini-css-extract-plugin
export default {"card":"carrier-select_card__UDJKA","cardContent":"carrier-select_cardContent__kWNVr","cardTitle":"carrier-select_cardTitle__biUQJ"};